import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BankDetailsDTO } from '@iota/iota-management-portal-v4-client';
import { Currency } from '../../constants-and-enums/currency';
import { PaymentMethodDescriptions, PaymentMethods } from '../../constants-and-enums/payment-method';

@Component({
    standalone: false,
    selector: 'app-bank-details',
    templateUrl: './bank-details.component.html',
    styleUrls: ['./bank-details.component.scss']
})
export class BankDetailsComponent implements OnInit {
    currencies = Object.keys(Currency).map((key) => Currency[key]);
    paymentMethods = PaymentMethods;

    editMode = false;

    @Input() bankDetails: BankDetailsDTO;

    @Output() save: EventEmitter<BankDetailsDTO> = new EventEmitter();
    @Output() cancelEdit: EventEmitter<string> = new EventEmitter();

    ngOnInit(): void {
        if (!this.bankDetails.bankDetailsId) {
            this.editMode = true;
        }
    }

    getPaymentMethodDescription(paymentMethod: string) {
        return PaymentMethodDescriptions.get(paymentMethod);
    }

    onSave(bankDetails: BankDetailsDTO) {
        this.save.emit(bankDetails);
        this.editMode = false;
    }

    onCancel() {
        this.cancelEdit.emit();
        this.editMode = false;
    }
}
